(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ModalEditOcorrenciaCtrl', ModalEditOcorrenciaController);

  ModalEditOcorrenciaController.$inject = [
    '$scope',
    'objeto',
    'LoadingService',
    'HistoricosService',
    'TiposOcorrenciasService',
    '$q',
    'OcorrenciasService',
    'MessagesService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function ModalEditOcorrenciaController($scope, objeto, LoadingService, HistoricosService, TiposOcorrenciasService,
    $q, OcorrenciasService, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.title = objeto.title;
    vm.data = {
      estadio: null,
      items: [],
      observacao: objeto.observacao
    };
    vm.estadios = [];
    vm.tipos = [];

    //////////////////////////////////////////
    // Bindable functions
    vm.save = save;
    vm.addType = addType;
    vm.removeType = removeType;
    vm.isInvalid = isInvalid;
    vm.canSave = canSave;
    vm.resetType = resetType;
    vm.setSituacao= setSituacao;
    vm.resetTypes = resetTypes;

    //////////////////////////////////////////
    // Function declarations

    function save() {
      LoadingService.showLoading();
      return OcorrenciasService
        .edit(objeto.sincId, vm.data)
        .then(() => {
          MessagesService.alert('Registro salvo com sucesso!');
          $scope.$close(true);
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível salvar o registro. Verifique os dados e tente novamente.');
        })
        .finally(LoadingService.hideLoading);
    }

    function addType() {
      vm.data.items.push({ type: null, value: {} });
    }

    function removeType(index) {
      vm.data.items.splice(index, 1);
    }

    function isInvalid(field) {
      field = $scope.ocorrenciaForm[field];
      if (!field) {
        return true;
      }
      return field.$dirty && field.$invalid;
    }

    function canSave() {
      return $scope.ocorrenciaForm.$valid && vm.data.items.length > 0;
    }

    function resetType(index) {
      vm.data.items[index].value = {};
    }

    function setSituacao(item, idIndicador) {
      const value = item.value[idIndicador];
      const indicador = _.find(item.type.indicadores, { cd_indicador: idIndicador });
      if (indicador.indicador.tipo === 'texto') {
        value.situacao = getSituacaoForTexto(value.valor1);
      } else if (indicador.indicador.tipo === 'percentual') {
        if (value.valor1 !== null && value.valor1 > 0 && value.valor2 !== null) {
          value.percentual = value.valor2 / value.valor1 * 100;
          value.situacao = getSituacaoForValor(value.percentual, indicador);
        }
      } else if (value.valor1 !== null) {
        value.situacao = getSituacaoForValor(+value.valor1, indicador);
      }
    }
    //eslint-disable-next-line
    function getSituacaoForValor(valor, indicador) {
      if (indicador.numero_faixas === 3) {
        if (valor > +indicador.controle) {
          return TYPES_STATUS_OPERATIONS.alerta;
        }
        if (valor > +indicador.equilibrio) {
          return TYPES_STATUS_OPERATIONS.controle;
        }
      } else {
        if (indicador.numero_faixas > 4) {
          if (valor > +indicador.emergencia) {
            return TYPES_STATUS_OPERATIONS.extremo;
          }
        }
        if (valor > +indicador.controle) {
          return TYPES_STATUS_OPERATIONS.alerta;
        }
        if (valor > +indicador.alto_equilibrio) {
          return TYPES_STATUS_OPERATIONS.controle;
        }
        if (valor > +indicador.equilibrio) {
          return TYPES_STATUS_OPERATIONS.alto_equilibrio;
        }
      }
      return TYPES_STATUS_OPERATIONS.equilibrio;
    }

    function getSituacaoForTexto(text) {
      switch (text) {
      case 'Alta':
        return TYPES_STATUS_OPERATIONS.alerta;
      case 'Média':
        return TYPES_STATUS_OPERATIONS.controle;
      case 'Baixa Média':
        return TYPES_STATUS_OPERATIONS.alto_equilibrio;
      case 'Extremo':
        return TYPES_STATUS_OPERATIONS.extremo;
      default:
        return TYPES_STATUS_OPERATIONS.equilibrio;
      }
    }

    function resetTypes() {
      vm.data.items = [];
      addType();
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();
    $q.all([
      HistoricosService.listEstadios({
        cultura: { id: objeto.params.atividade_id }
      }),
      TiposOcorrenciasService.list({
        tipo: { id: objeto.tipo },
        noPaginate: true
      })
    ])
      .then(([estadios, tipos]) => {
        vm.estadios = estadios.data;
        vm.data.estadio = _.find(vm.estadios, { id: objeto.estadio.id });
        vm.tipos = _.sortBy(tipos.data, [(t) => _.deburr(t.descricao)]);
        vm.data.items = objeto.selectedItems.map((item) => {
          const value = {};
          item.indicadores.forEach((indicador) => {
            value[indicador.id] = {};
            value[indicador.id].valor1 = indicador.valor1;
            if (indicador.valor2) {
              value[indicador.id].valor2 = indicador.valor2;
            }
            if (indicador.tipo === 'percentual') {
              value[indicador.id].percentual = indicador.percentual;
            } else if (indicador.tipo === 'valor') {
              value[indicador.id].percentual = indicador.valor1 / (indicador.controle + 1) * 100;
            }
            if (indicador.situacao) {
              value[indicador.id].situacao = TYPES_STATUS_OPERATIONS[indicador.situacao.descricaoJson];
            }
          });
          return {
            type: _.find(vm.tipos, { id: item.id }),
            value
          };
        });
      })
      .catch((error) => {
        console.error(error);
        MessagesService.alert('Não foi possível carregar os dados necessários, tente novamente.');
        $scope.$close(false);
      })
      .finally(LoadingService.hideLoading);
  }
}());
